// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2JKEg","empty":"ModalGraph_empty__2JJkJ"};